import React, { useState } from "react";
import {
  Spin,
  InputNumber,
  Checkbox,
  Collapse,
  Button,
  Form,
  message,
} from "antd";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import { useDispatch } from "react-redux";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";
import {
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setQuickQuotePost,
} from "../../../Redux/actions/CommercialSlice";
import { SelectAddons } from "../../../Redux/actions/NumBikeation";

const CommercialAddons = ({
  CommerDetail,
  auth,
  QuotePost,
  QuoteInput,
  SQQAddons,
  CurrentTP,
  loading,
  setLoading,
  setSkullloading,
}) => {
  const { Panel } = Collapse;
  const dispatch = useDispatch();
  const [activeKey, setActiveKey] = useState(["1", "2"]);
  const [electricalShow, setElectricalShow] = useState(QuotePost?.electrical);
  const [NonElectricalShow, setNonElectricalShow] = useState(
    QuotePost?.nonElectrical
  );
  const [selectedOption, setSelectedOption] = useState(
    electricalShow ? "electrical" : NonElectricalShow ? "nonElectrical" : null
  );
  const onChange = (keys) => {
    //console.log(keys)
    setActiveKey(keys);
  };

  const handlePanel1Click = () => {
    setActiveKey(activeKey.length === 0 ? ["1", "2", "3", "4"] : []);
  };

  const onCheckChange = (e) => {
    // console.log('checked = ', e);
    if (e.target.checked === true) {
      setSkullloading(true);
      setLoading(true);
      // console.log('checked = ', e.target.value);
      let addons = e.target.value;
      // setSelectedAddon(prevSelected => [...prevSelected, addons]);
      dispatch(SelectAddons([...SQQAddons, addons]));
      const updatedQuotePost = {
        ...QuotePost,
        [addons]: true,
        currentThirdPartyPolicy:
          QuotePost?.product_code === "PVP" ? null : CurrentTP,
      };
      // console.log(updatedQuotePost)
      axiosCommercial
        .post(
          `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
          updatedQuotePost
        )
        .then((res) => {
          if (res.status === 200) {
            // if (!res.data.error) {
            // let data = {
            //     data: res.data.data,
            // };
            const data = res?.data?.data;
            //console.log(data)
            // console.log("data-----------------",data)
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(setCommercialErrQuotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(setCommercialQuickQuotes(updatedData));
            //console.log(data)
            //dispatch(quick_quotes(data));
            dispatch(setQuickQuotePost(updatedQuotePost));
            setSkullloading(false);
            setLoading(false);
            // } else {
            // setLoading(false)
            // message.error(res.data.error.validationMessages.join(","));
            // }
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setSkullloading(false);
          setLoading(false);
          //message.error(err.response.data.error);
        });
    } else if (e.target.checked === false) {
      setSkullloading(true);
      setLoading(true);
      // console.log('checked = ', e.target.value);
      let addons = e.target.value;
      const updatedSelectedAddon = SQQAddons.filter(
        (selected) => selected !== addons
      );
      //setSelectedAddon(updatedSelectedAddon);
      dispatch(SelectAddons(updatedSelectedAddon));
      const updatedQuotePost = {
        ...QuotePost,
        [addons]: false,
      };
      // console.log(updatedQuotePost)
      axiosCommercial
        .post(
          `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
          updatedQuotePost
        )
        .then((res) => {
          if (res.status === 200) {
            // if (!res.data.error) {
            // let data = {
            //     data: res.data.data,
            // };
            const data = res?.data?.data;
            //console.log(data)
            // console.log("data-----------------",data)
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(setCommercialErrQuotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(setCommercialQuickQuotes(updatedData));
            //console.log(data)
            //dispatch(quick_quotes(data));
            dispatch(setQuickQuotePost(updatedQuotePost));
            setSkullloading(false);
            setLoading(false);
            // } else {
            // setLoading(false)
            // message.error(res.data.error.validationMessages.join(","));
            // }
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setSkullloading(false);
          setLoading(false);
          //message.error(err.response.data.error);
        });
    }
  };

  const onEectricalChange = (e) => {
    if (e.target.checked === true) {
      setSkullloading(false);
      setLoading(false);
      let Electric = e.target.value;
      console.log(Electric);
      if (Electric === "electrical") {
        setSelectedOption("electrical");
        const updatedQuotePostEL = {
          ...QuotePost,
          electrical: true,
          nonElectrical: false,
        };
        dispatch(setQuickQuotePost(updatedQuotePostEL));
        setElectricalShow(true);
        setNonElectricalShow(false);
      } else if (Electric === "nonElectrical") {
        setSelectedOption("nonElectrical");
        const updatedQuotePostEL = {
          ...QuotePost,
          electrical: false,
          nonElectrical: true,
        };
        dispatch(setQuickQuotePost(updatedQuotePostEL));
        setElectricalShow(false);
        setNonElectricalShow(true);
      }
    } else if (e.target.checked === false) {
      setElectricalShow(false);
      setNonElectricalShow(false);
      setSkullloading(true);
      setLoading(true);
      let Electric = e.target.value;
      console.log(Electric);
      const updatedQuotePost = {
        ...QuotePost,
        [Electric]: false,
        electricalinsuredamount: null,
        nonElectricalinsuredamount: null,
      };
      setSkullloading(false);
      setLoading(false);
      dispatch(setQuickQuotePost(updatedQuotePost));
      if (
        (e.target.checked === false && QuotePost?.electricalinsuredamount) ||
        QuotePost?.nonElectricalinsuredamount
      ) {
        setSkullloading(true);
        setLoading(true);
        axiosCommercial
          .post(
            `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
            updatedQuotePost
          )
          .then((res) => {
            if (res.status === 200) {
              const Udata = res?.data?.data;
              //console.log("data-----------------",data)
              const errData = Udata?.filter(
                (item) => "status" in item && item.status === "failed"
              );
              dispatch(setCommercialErrQuotes(errData));
              const filteredData = Udata?.filter(
                (item) => "status" in item && item.status === "success"
              );
              const updatedData = filteredData?.map((item) => ({
                ...item,
                IsGst: true,
              }));
              dispatch(setCommercialQuickQuotes(updatedData));
              dispatch(setQuickQuotePost(updatedQuotePost));
              setSkullloading(false);
              setLoading(false);
            }
          })
          .catch((err) => {
            console.log(err?.response?.data);
            setLoading(false);
            setSkullloading(false);
          });
      }
    }
  };
  const onFinish = (values) => {
    // console.log('values',values)
    // console.log(selectedOption)
    setLoading(true);
    // console.log(typeof values.electricalinsuredamount)
    let updatedElectric;
    let updatedNonElectric;
    if (selectedOption === "electrical") {
      setSkullloading(true);
      setLoading(true);
      updatedElectric = {
        ...QuotePost,
        electrical: true,
        electricalinsuredamount: values.electricalinsuredamount,
        // electricalminallowed: selectedObjects?.electrical.minAllowed,
        // electricalmaxallowed: selectedObjects?.electrical.maxAllowed,
      };
      axiosCommercial
        .post(
          `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
          updatedElectric
        )
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data;
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(setCommercialErrQuotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(setCommercialQuickQuotes(updatedData));
            dispatch(setQuickQuotePost(updatedElectric));
            setLoading(false);
            setSkullloading(false);
          }
        })
        .catch((err) => {
          console.log(err?.response?.data);
          setLoading(false);
          setSkullloading(false);
          //message.error(err.response.data.error);
        });
    } else if (selectedOption === "nonElectrical") {
      setLoading(true);
      setSkullloading(true);
      updatedNonElectric = {
        ...QuotePost,
        nonElectrical: true,
        nonElectricalinsuredamount: values.nonElectricalinsuredamount,
      };
      //console.log(updatedNonElectric)
      axiosCommercial
        .post(
          `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
          updatedNonElectric
        )
        .then((res) => {
          if (res.status === 200) {
            const data = res?.data?.data;
            const errData = data?.filter(
              (item) => "status" in item && item.status === "failed"
            );
            dispatch(setCommercialErrQuotes(errData));
            const filteredData = data?.filter(
              (item) => "status" in item && item.status === "success"
            );
            const updatedData = filteredData?.map((item) => ({
              ...item,
              IsGst: true,
            }));
            dispatch(setCommercialQuickQuotes(updatedData));
            dispatch(setQuickQuotePost(updatedNonElectric));
            setLoading(false);
            setSkullloading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          setSkullloading(false);
          console.log(err.response.data.error);
          message.error(err.response.data.error);
        });
    }
  };
  return (
    <Spin spinning={loading}>
      <div className="add0n-btn">
        <div className="adondiiv">
          Addons & Covers
          <span onClick={handlePanel1Click}>
            {activeKey.length > 0 ? (
              <MinusCircleOutlined />
            ) : (
              <PlusCircleOutlined />
            )}
          </span>
        </div>
      </div>
      <Collapse activeKey={activeKey} onChange={onChange}>
        <Panel header="CPA" key="1">
          {QuotePost?.policyHolderType === "COMPANY" ||
          QuoteInput?.insuranceProductCode === "Bundled" ||
          QuoteInput?.insuranceProductCode === "PVS" ? null : (
            <div className="addon-collapse-inner">
              <Checkbox
                onChange={onCheckChange}
                value="personalAccident"
                className="d-flex align-items-center"
                checked={QuotePost?.personalAccident}
              >
                Compulsory Personal Accident
              </Checkbox>
            </div>
          )}
        </Panel>

        <Panel header="Addons" key="2" className="addon-pannel">
          {QuotePost?.product_code === "PVT" ||
          QuoteInput?.productCode === "PVT" ? null : (
            <div className="addon-collapse-inner">
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="partsDepreciation"
                checked={QuotePost?.partsDepreciation}
              >
                Zero Depreciation
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="consumables"
                checked={QuotePost?.consumables}
              >
                consumables
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="engineProtection"
                checked={QuotePost?.engineProtection}
              >
                Engine protector
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="returnToInvoice"
                checked={QuotePost?.returnToInvoice}
              >
                Return To Invoice
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="roadSideAssistance"
                checked={QuotePost?.roadSideAssistance}
              >
                Road Side Assistance
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="emergencyMedicalExpenses"
                checked={QuotePost?.emergencyMedicalExpenses}
              >
                Emergency Medical Expenses
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="keyAndLockProtect"
                checked={QuotePost?.keyAndLockProtect}
              >
                Key Cover
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="personalBelonging"
                checked={QuotePost?.personalBelonging}
              >
                Loss Of Personal Belongings
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                className="add_on_checkbx"
                value="tyreProtection"
                checked={QuotePost?.tyreProtection}
              >
                Tyre Secure
              </Checkbox>
              {/* <Checkbox onChange={onCheckChange} className="add_on_checkbx" value='WindshieldGlass' checked={QuotePost?.WindshieldGlass}>Windshield Glass</Checkbox>             */}
            </div>
          )}
        </Panel>
        <Panel header="Additional Cover" key="3">
          {CommerDetail?.commercialType === "GOODS COMMERCIAL VEHICLE" && (
            <div className="addon-collapse-inner">
              <Checkbox
                onChange={onCheckChange}
                value="isBiFuelKit"
                checked={QuotePost?.isBiFuelKit}
              >
                Is Bi-fuel Kit?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="paCoverUnNamedPerson"
                checked={QuotePost?.paCoverUnNamedPerson}
              >
                PA Cover for unnamed Persons?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="paCoverPaidDriver"
                checked={QuotePost?.paCoverPaidDriver}
              >
                PA Cover for paid driver?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="LLiabilityEmployee"
                checked={QuotePost?.LLiabilityEmployee}
              >
                Legal liability for employee?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="LLiabilityPaidDriver"
                checked={QuotePost?.LLiabilityPaidDriver}
              >
                Legal liability for paid driver?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="LLiabilityCoolie"
                checked={QuotePost?.LLiabilityCoolie}
              >
                Legal liability for coolie?
              </Checkbox>
            </div>
          )}
          {CommerDetail?.commercialType === "PASSENGER CARRYING VEHICLE" && (
            <div className="addon-collapse-inner">
              <Checkbox
                onChange={onCheckChange}
                value="isElectricalAccessory"
                checked={QuotePost?.isElectricalAccessory}
              >
                Electrical Accessory?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="isNonElectricalAccessory"
                checked={QuotePost?.isNonElectricalAccessory}
              >
                Non-Electrical Accessory?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="isBiFuelKit"
                checked={QuotePost?.isBiFuelKit}
              >
                Is Bi-fuel Kit?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="paCoverPaidDriver"
                checked={QuotePost?.paCoverPaidDriver}
              >
                PA Cover for paid driver?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="paCoverUnNamedPerson"
                checked={QuotePost?.paCoverUnNamedPerson}
              >
                PA Cover for unnamed Persons?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="fairPayingPassenger"
                checked={QuotePost?.fairPayingPassenger}
              >
                Is Fair Paying Passenger?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="nonFairPayingPassenger"
                checked={QuotePost?.nonFairPayingPassenger}
              >
                Is Non-Fair Paying Passenger?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="LLiabilityPaidDriver"
                checked={QuotePost?.LLiabilityPaidDriver}
              >
                Legal liability to paid driver?
              </Checkbox>
              <Checkbox
                onChange={onCheckChange}
                value="fiberGlassFuelTank"
                checked={QuotePost?.fiberGlassFuelTank}
              >
                Fiber-Glass Fuel Tank
              </Checkbox>
            </div>
          )}
        </Panel>
        <Panel header="Accessories" key="4">
          {QuotePost?.product_code === "PVT" ||
          QuoteInput?.productCode === "PVT" ? null : (
            <div className="addon-collapse-inner">
              <Form
                onFinish={onFinish}
                layout="vertical"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Checkbox
                  value="electrical"
                  onChange={onEectricalChange}
                  checked={QuotePost?.electrical}
                >
                  Electrical
                </Checkbox>
                {electricalShow ? (
                  <>
                    <Form.Item
                      name="electricalinsuredamount"
                      initialValue={
                        QuotePost?.electricalinsuredamount
                          ? QuotePost?.electricalinsuredamount
                          : null
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Electrical Amount",
                        },
                      ]}
                    >
                      <InputNumber style={{ width: "60%" }} />
                    </Form.Item>
                  </>
                ) : null}
                <Checkbox
                  value="nonElectrical"
                  onChange={onEectricalChange}
                  checked={QuotePost?.nonElectrical}
                >
                  Non Electrical
                </Checkbox>
                {NonElectricalShow ? (
                  <>
                    <Form.Item
                      name="nonElectricalinsuredamount"
                      initialValue={
                        QuotePost?.nonElectricalinsuredamount
                          ? QuotePost?.nonElectricalinsuredamount
                          : null
                      }
                      rules={[
                        {
                          required: true,
                          message: "Please Enter NonElectrical Amount",
                        },
                      ]}
                    >
                      <InputNumber style={{ width: "60%" }} />
                    </Form.Item>
                  </>
                ) : null}
                {(electricalShow || NonElectricalShow) && (
                  <Form.Item style={{ textAlign: "center", marginTop: "12px" }}>
                    <Button loading={loading} type="primary" htmlType="submit">
                      Update
                    </Button>
                  </Form.Item>
                )}
              </Form>
            </div>
          )}
        </Panel>

        <Panel header="Discounts/Deductibles" key="5">
          {QuoteInput?.insuranceProductCode === "Bundled" ||
          QuoteInput?.insuranceProductCode === "20203" ? null : (
            <div className="addon-collapse-inner">
              {CommerDetail?.commercialType ===
                "PASSENGER CARRYING VEHICLE" && (
                <Checkbox
                  onChange={onCheckChange}
                  value="isAntiTheft"
                  checked={QuotePost?.isAntiTheft}
                >
                  Anti-Theft Device?
                </Checkbox>
              )}
              <Checkbox
                onChange={onCheckChange}
                value="isTPPD"
                checked={QuotePost?.isTPPD}
              >
                TPPD restricted to 6000?
              </Checkbox>
            </div>
          )}
        </Panel>
      </Collapse>
    </Spin>
  );
};

export default CommercialAddons;
